import Cookies from 'js-cookie'
import { applyFilter } from './filtergroups'

const FETCH_URL = 'https://intelligente-hp-dehn.wysiwyg.de/eventlabel.json'

const Homepage = function () {

  const { isFront, currentLanguage } = drupalSettings.path
  const cookieName = 'hp-solutions-category-' + currentLanguage

  function init() {
    const solutionsCategories = document.querySelector('.button-row.postcard-header')
    if (!solutionsCategories) return

    // Check if we are on German homepage
    if (!(isFront && currentLanguage === 'de')) return

    // Check if we are not in CMS Layout Mode
    if (document.getElementById('layout-builder')) return

    const category = Cookies.get(cookieName)
    if (category) {
      applyFilterByCategory(category)
    } else {
      fetchCategory().then(applyFilterByCategory)
    }
  }

  function applyFilterByCategory(category) {
    if (!category) return

    const filterTarget = document.querySelector(`[data-filter="${category}"]`)
    if (filterTarget) {
      applyFilter({
        delegateTarget: filterTarget.closest('.button-row.postcard-header'),
        currentTarget: filterTarget
      })
    }
  }

  async function fetchCategory() {
    const data = await fetch(FETCH_URL, { method: 'get' }).then(res => res.json())
    const key = 'de_active_category_protection_solution'

    if (data.hasOwnProperty(key)) {
      const category = data[key]
      if (category) {
        Cookies.set(cookieName, category)
        return category
      }
    }
  }

	return {
		init,
	}
}()

export default Homepage
